import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=7f1429c6&scoped=true&"
import script from "./CardLink.vue?vue&type=script&lang=js&"
export * from "./CardLink.vue?vue&type=script&lang=js&"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=7f1429c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1429c6",
  null
  
)

export default component.exports